<template>
  <b-overlay :show="showbase" rounded="md">
    <b-container id="main-container" fluid style>
      <b-row style="width: 100%; background-color: #e8e8ea" align-h="center">
        <b-col class cols="12">
          <nav-header></nav-header>
        </b-col>
      </b-row>

      <b-row style="width: 100%; margin-top: 60px" align-h="center">
        <b-col
          cols="12"
          style="padding-left: 0; padding-right: 0"
          class="main-jumbotron"
        >
          <b-row class="pt-3 hide-when-small">
            <b-col
              style="
                font-size: 36px;
                border-bottom: 1px solid #e8e7e8;
                padding-left: 0;
                padding-right: 0;
                padding-bottom: 15px;
                line-height: 1.2;
                text-align: center;
              "
              class="center-align-small pb-2"
              >The Truthbrush Reviews</b-col
            >
          </b-row>
          <b-row
            class="pt-5"
            style="border-bottom: 1px solid #e8e7e8; padding-bottom: 35px"
          >
            <b-col cols="12" md="9">
              <b-row align-h="start">
                <b-col
                  cols="12"
                  md="3"
                  align-self="center"
                  class="align-center-small pl-0 pr-0"
                >
                  <b-img
                    src="img/t1-review-icon.png"
                    center
                    style="width: 100px"
                    v-if="reviewproductid == 't1'"
                  >
                  </b-img>
                  <b-img
                    src="img/t2-review-icon.png"
                    center
                    style="width: 100px"
                    v-if="reviewproductid == 't2'"
                  >
                  </b-img>
                </b-col>

                <b-col cols="12" md="9" class="pl-0 pr-0">
                  <b-row align-v="center">
                    <b-col
                      cols="12"
                      class="center-align-small"
                      align-self="center"
                    >
                      <b-row class="pt-2-small" v-if="reviewproductid == 't1'"
                        ><h1>The Truthbrush</h1></b-row
                      >
                      <b-row class="pt-2-small" v-if="reviewproductid == 't2'"
                        ><h1>Truthbrush Pro</h1></b-row
                      >
                      <b-row class="pt-1-small pt-2">
                        <b-col
                          class="pl-0 pr-0"
                          style="height: 1.2rem"
                          cols="12"
                        >
                          <ReviewPanel ref="reviewpanel"></ReviewPanel>
                        </b-col>
                      </b-row>
                      <b-row class="pt-4">
                        <b-col cols="12" class="pl-0 pr-0 center-align-small">
                          <router-link
                            to="/select_t1"
                            v-if="reviewproductid == 't1'"
                          >
                            <b-button
                              variant="primary"
                              pill
                              class="hub-blue btn-truthbrush select-btn"
                              style="min-width: 200px"
                              size="lg"
                              >Shop Now</b-button
                            >
                          </router-link>
                          <router-link
                            to="/select_t2"
                            v-if="reviewproductid == 't2'"
                          >
                            <b-button
                              variant="primary"
                              pill
                              class="hub-blue btn-truthbrush select-btn"
                              style="min-width: 200px"
                              size="lg"
                              >Shop Now</b-button
                            >
                          </router-link>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
            <b-col
              align-self="center"
              class="center-align-small pt-2-small"
              style="text-align: right"
            >
              <u v-b-modal.modal-review>Write a reivew</u>
            </b-col>
          </b-row>

          <b-row class="pt-5" style="">
            <b-col>
              <b-row
                v-for="(item, index) in reviews"
                :key="index"
                class="pb-4"
                style="
                  border-bottom: 1px solid #e8e7e8;
                  padding-bottom: 35px;
                  margin-bottom: 35px;
                "
              >
                <b-col cols="12" md="3" class="hide-when-small">
                  <b-row>
                    <b-col>
                      <b style="font-size: 18px">{{ item.name }}</b>
                    </b-col>
                  </b-row>
                  <b-row class="pt-1">
                    <b-col style="color: #6c6f78">
                      {{ item.city }}, {{ item.state }}
                    </b-col>
                  </b-row>
                  <b-row class="pt-1">
                    <b-col style="color: #6c6f78">
                      {{ prettyDate(item.createdtime) }}
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="12" md="9" class="pl-pr-0-sm">
                  <b-row class="pb-2">
                    <b-col class="pl-0 pr-0">
                      <b-img
                        src="img/star-full.jpg"
                        class="review-stars"
                      ></b-img>
                      <b-img
                        src="img/star-full.jpg"
                        class="review-stars"
                        v-if="item.stars >= 2"
                      ></b-img>
                      <b-img
                        src="img/star-full.jpg"
                        class="review-stars"
                        v-if="item.stars >= 3"
                      ></b-img>
                      <b-img
                        src="img/star-full.jpg"
                        class="review-stars"
                        v-if="item.stars >= 4"
                      ></b-img>
                      <b-img
                        src="img/star-full.jpg"
                        class="review-stars"
                        v-if="item.stars >= 5"
                      ></b-img>
                    </b-col>
                  </b-row>
                  <b-row
                    class="pt-1"
                    v-if="item.title != null || item.title != ''"
                  >
                    <b style="font-size: 18px">{{ item.title }}</b>
                  </b-row>
                  <b-row
                    class="pt-1"
                    v-if="item.comment != null || item.comment != ''"
                    style="color: #6c6f78; line-height: 1.5"
                  >
                    {{ item.comment }}
                  </b-row>
                  <b-row class="hide-when-big pb-3 pt-3">
                    <b-col class="pl-0 pr-0">
                      <b-row>
                        <b-col class="pl-0 pr-0">
                          <b style="font-size: 14px">{{ item.name }}</b>
                        </b-col>
                      </b-row>
                      <b-row class="pt-1">
                        <b-col class="pl-0 pr-0" style="color: #6c6f78">
                          {{ item.city }}, {{ item.state }}
                        </b-col>
                      </b-row>
                      <b-row class="pt-1">
                        <b-col class="pl-0 pr-0" style="color: #6c6f78">
                          {{ prettyDate(item.createdtime) }}
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row class="pt-1">
                    <b-col cols="12" sm="6" class="pl-0 pr-0">
                      <b>{{ item.thumbup }}</b> people found this helpful
                    </b-col>
                    <b-col cols="12" sm="6" class="pl-pr-0-sm">
                      <b
                        @click="thumbup(index)"
                        style="cursor: pointer; padding-right: 10px"
                        ><u>Helpful</u></b
                      >
                      |
                      <b
                        style="padding-left: 10px; cursor: pointer"
                        @click="thumbdown(index)"
                        mou
                        ><u>Not Helpful</u></b
                      >
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row class="pb-5">
            <b-col class="pt-1">
              <b
                @click="previousPage(-1)"
                style="cursor: pointer; font-size: 18px"
                >&laquo; Previous page</b
              >
            </b-col>
            <b-col class="pt-1" style="text-align: right">
              <b
                @click="previousPage(1)"
                style="cursor: pointer; font-size: 18px"
                >Next page &raquo;</b
              >
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-row style="width: 100%">
        <nav-footer></nav-footer>
      </b-row>

      <b-modal
        id="modal-review"
        ref="modal-review"
        size="xl"
        centered
        hide-footer
      >
        <b-overlay :show="show" rounded="md">
          <b-row>
            <b-col class="pl-pr-0-sm">
              <b-form style="width: 100%" @submit="onSubmit">
                <b-col class="pl-0 pr-0">
                  <b-row>
                    <b
                      style="
                        font-size: 28px;
                        padding-left: 0px;
                        text-align: center !important;
                        width: 100%;
                      "
                      class="h2-font"
                      >Review your Truthbrush</b
                    >
                  </b-row>
                  <b-row class="pt-2">
                    <b>* Required Field</b>
                  </b-row>
                  <b-row class="pt-3" align-h="between">
                    <b-col cols="12" md="6" style='padding-right:10px;' class="pl-0 pb-4-sm pl-pr-0-sm">
                      <b-form-group
                        class="pl-pr-0-sm"
                      >
                        <b-form-input
                          v-model="form.name"
                          placeholder="Name (*)"
                          id="review-input-name"
                          type="text"
                          :state="isEmptyString(form.name)"
                          :class="needAdditionalPadding(form.name)"
                        ></b-form-input>
                        <span class="innerlabel" v-if="form.name"
                          >Name (*)</span
                        >
                      </b-form-group>
                      <b-form-invalid-feedback
                        id="review-input-name"
                        class="pl-0 pt-1"
                      >
                        Name cannot be empty
                      </b-form-invalid-feedback>
                    </b-col>

                    <b-col cols="12" md="6" style='' class="pr-0 pl-0 pl-pr-0-sm">
                      <b-form-group
                        class="pl-pr-0-sm"
                      >
                        <b-form-input
                          v-model="form.email"
                          id="review-input-email"
                          placeholder="Email (*)"
                          autocomplete="email"
                          type="email"
                          :state="isValidEmail(form.email) && isEmptyString(form.email)"
                          :class="needAdditionalPadding(form.email)"
                        ></b-form-input>
                        <span class="innerlabel" v-if="form.email">Email (*)</span>
                      </b-form-group>
                      <b-form-invalid-feedback
                        id="review-input-email"
                        class="pl-0 pt-1"
                      >
                        Invalid email
                      </b-form-invalid-feedback>
                    </b-col>
                  </b-row>

                  <b-row class="pt-4-big">
                    <b-col lg="12" cols="12" class="pl-0 pr-0">
                      <b-row> </b-row>
                      <b-row>
                        <b-col lg="4" cols="12" class="pt-0 pl-0 pr-0">
                          <b-row>
                            <b-col
                              class="pl-0 pr-0-small pr-0-md"
                              style="padding-bottom: 0"
                            >
                              <b-form-group>
                                <b-form-select
                                  v-model="form.country"
                                  type="text"
                                  :options="getCountryOptions()"
                                  required
                                  autocomplete="shipping country"
                                  name="country"
                                  :class="needAdditionalPadding(form.country)"
                                  @change="changecountry()"
                                  class="select-special"
                                ></b-form-select>
                                <span
                                  class="innerlabel reduced_pl_pr"
                                  v-if="form.country"
                                  >Country (*)
                                </span>
                              </b-form-group>
                              <b-form-invalid-feedback
                                id="form-input-country"
                                class="pl-0 pt-1"
                              >
                                Country cannot be empty
                              </b-form-invalid-feedback>
                            </b-col>
                          </b-row>
                        </b-col>

                        <b-col lg="4" cols="12" class="pt-0 pb-0 pl-0 pr-0">
                          <b-row>
                            <b-col class="pl-0 pr-0-small pr-0-md">
                              <b-form-group>
                                <b-form-input
                                  id="form-input-city"
                                  v-model="form.city"
                                  autocomplete="shipping locality"
                                  placeholder="City (*)"
                                  :class="needAdditionalPadding(form.city)"
                                  :state="isEmptyString(form.city)"
                                  type="text"
                                ></b-form-input>
                                <span class="innerlabel" v-if="form.city"
                                  >City (*)</span
                                >
                              </b-form-group>
                              <b-form-invalid-feedback
                                id="form-input-city"
                                class="pl-0 pt-1"
                              >
                                City cannot be empty
                              </b-form-invalid-feedback>
                            </b-col>
                          </b-row>
                        </b-col>

                        <b-col lg="4" cols="12" class="pt-0 pl-0 pr-0">
                          <b-row>
                            <b-col class="pl-0 pr-0">
                              <b-form-group>
                                <b-form-select
                                  v-model="form.state"
                                  type="text"
                                  :options="getUSStatesOptions()"
                                  required
                                  autocomplete="shipping region"
                                  name="state"
                                  class="select-special"
                                  :class="needAdditionalPadding(form.state)"
                                  v-if="form.country == 'US'"
                                ></b-form-select>
                                <b-form-select
                                  v-model="form.state"
                                  type="text"
                                  :options="getCAStatesOptions()"
                                  required
                                  autocomplete="shipping region"
                                  name="state"
                                  class="select-special"
                                  :class="needAdditionalPadding(form.state)"
                                  v-else-if="form.country == 'CA'"
                                ></b-form-select>
                                <b-form-select
                                  v-model="form.state"
                                  type="text"
                                  :options="getAUStatesOptions()"
                                  required
                                  autocomplete="shipping region"
                                  name="state"
                                  class="select-special"
                                  :class="needAdditionalPadding(form.state)"
                                  v-else-if="form.country == 'AU'"
                                ></b-form-select>

                                <b-form-input
                                  id="form-input-state"
                                  v-model="form.state"
                                  placeholder="State/Province (*)"
                                  type="text"
                                  autocomplete="shipping region"
                                  :class="needAdditionalPadding(form.state)"
                                  :state="isEmptyString(form.state)"
                                  v-else
                                ></b-form-input>
                                <span
                                  class="innerlabel pl-0 reduced_pl_pr"
                                  v-if="form.state && form.country == 'US'"
                                  >State (*)</span
                                >
                                <span
                                  class="innerlabel pl-0 reduced_pl_pr"
                                  v-if="form.state && form.country != 'US'"
                                  >State / Province (*)</span
                                >
                              </b-form-group>

                              <b-form-invalid-feedback
                                id="form-input-state"
                                class="pl-0 pt-1"
                              >
                                State cannot be empty
                              </b-form-invalid-feedback>
                            </b-col>
                          </b-row>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <b-row class="pt-2">
                    <b-col cols="12" class="pl-0 pr-0">
                      <hr
                        style="
                          width: 100%;
                          border: 0.5px solid black;
                          margin-left: 0;
                        "
                      />
                    </b-col>
                  </b-row>
                  <b-row class="pt-4">* Overall Rating</b-row>
                  <b-row class="pt-3">
                    <b-img
                      src="img/star-empty.jpg"
                      class="review-star-form"
                      @click="clickStar(1)"
                      v-if="form.rating == 0"
                    ></b-img>
                    <b-img
                      src="img/star-full.jpg"
                      class="review-star-form"
                      @click="clickStar(1)"
                      v-if="form.rating >= 1"
                    ></b-img>

                    <b-img
                      src="img/star-empty.jpg"
                      class="review-star-form"
                      @click="clickStar(2)"
                      v-if="form.rating < 2"
                    ></b-img>
                    <b-img
                      src="img/star-full.jpg"
                      class="review-star-form"
                      @click="clickStar(2)"
                      v-if="form.rating >= 2"
                    ></b-img>

                    <b-img
                      src="img/star-empty.jpg"
                      class="review-star-form"
                      @click="clickStar(3)"
                      v-if="form.rating < 3"
                    ></b-img>
                    <b-img
                      src="img/star-full.jpg"
                      class="review-star-form"
                      @click="clickStar(3)"
                      v-if="form.rating >= 3"
                    ></b-img>

                    <b-img
                      src="img/star-empty.jpg"
                      class="review-star-form"
                      @click="clickStar(4)"
                      v-if="form.rating < 4"
                    ></b-img>
                    <b-img
                      src="img/star-full.jpg"
                      class="review-star-form"
                      @click="clickStar(4)"
                      v-if="form.rating >= 4"
                    ></b-img>

                    <b-img
                      src="img/star-empty.jpg"
                      class="review-star-form"
                      @click="clickStar(5)"
                      v-if="form.rating < 5"
                    ></b-img>
                    <b-img
                      src="img/star-full.jpg"
                      class="review-star-form"
                      @click="clickStar(5)"
                      v-if="form.rating >= 5"
                    ></b-img>
                  </b-row>

                  <b-row class="pt-4">
                    <b-col cols="12" md="6" class="pl-0 pr-0">
                      <b-form-input
                        v-model="form.title"
                        placeholder="Title (*)"
                        id="form-input-title"
                        type="text"
                        :state="isEmptyString(form.title)"
                        :class="needAdditionalPadding(form.title)"
                      ></b-form-input>
                      <span class="innerlabel" v-if="form.title"
                        >Title (*)</span
                      >
                      <b-form-invalid-feedback
                        id="form-input-city"
                        class="pl-0 pt-1"
                      >
                        Title cannot be empty
                      </b-form-invalid-feedback>
                    </b-col>
                  </b-row>

                  <b-row class="pt-4">
                    <b-col cols="12" md="12" class="pl-0 pr-0">
                      <b-form-textarea
                        rows="6"
                        v-model="form.comment"
                        placeholder="Review - How does it feel to use the product? How do you like the app and service? Has the Truthbrush helped your family reach your goals?"
                        id="form-input-comment"
                        type="text"
                        :class="needAdditionalPadding(form.comment)"
                      ></b-form-textarea>
                    </b-col>
                  </b-row>

                  <b-row class="pb-5">
                    <b-col
                      cols="12"
                      style="
                        text-align: left;
                        padding-top: 25px;
                        padding-bottom: 15px;
                      "
                      class="pl-0 pr-0 center-align-small"
                    >
                      <b-button
                        variant="primary"
                        pill
                        class="hub-blue btn-truthbrush select-btn"
                        style="min-width: 250px"
                        size="lg"
                        @click="onSubmit()"
                        >Submit</b-button
                      >
                    </b-col>
                  </b-row>
                </b-col>
              </b-form>
            </b-col>
          </b-row>
        </b-overlay>
      </b-modal>
    </b-container>
  </b-overlay>
</template>

<script>
import NavHeader from "./../components/NavHeader";
import NavFooter from "./../components/NavFooter";
import store from "../store";
import ReviewPanel from "./../components/ReviewPanel";
import { getReviews, postReview } from "../api/store.js";
export default {
  name: "Contact",
  components: {
    NavHeader,
    NavFooter,
    ReviewPanel,
  },
  data() {
    return {
      show: false,
      showbase: false,
      reviews: [],
      pagestack: [],
      thumbs: {},
      reviewproductid: "t1",
      form: {
        name: null,
        email: null,
        state: "Alabama",
        city: null,
        country: "US",
        rating: 0,
        title: null,
        comment: null,
      },
    };
  },
  methods: {
    clickStar(star) {
      this.form.rating = star;
    },
    getCountryOptions() {
      return this.$store.state.countries;
    },
    getUSStatesOptions() {
      return this.$store.state.statesusa;
    },
    getAUStatesOptions() {
      return this.$store.state.statesaustralia;
    },
    getCAStatesOptions() {
      return this.$store.state.statescanada;
    },
    changecountry() {
      //console.log(this.form.country);
      if (this.form.country == "US") {
        this.form.state = "Alabama";
      } else if (this.form.country == "CA") {
        this.form.state = "Alberta";
      } else if (this.form.country == "AU") {
        this.form.state = "New South Wales";
      } else {
        this.form.state = null;
      }
    },
    needAdditionalPadding(str) {
      if (str == null || str == "") {
        return "nopadding";
      } else {
        return "additionalPadding";
      }
    },
    isValidEmail(email) {
      if (email == null) return email;
      if (email == "") return true;
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    isEmptyString(index) {
      if (index == null) return index;
      if (index.trim() == "") {
        return false;
      }
      return true;
    },
    prettyDate(t) {
      var hours = (Date.now() - Date.parse(t)) / 1000 / 3600;
      if (hours < 2) {
        return "Few moments ago";
      }
      if (hours < 24) {
        return "Few hours ago";
      } else if (hours < 168) {
        if (hours < 48) {
          return "One day ago";
        }
        return Math.floor(hours / 24).toFixed(0) + " days ago";
      } else {
        var days = hours / 24.0;
        var weeks = days / 7.0;
        if (weeks < 2) {
          return "One week ago";
        } else if (weeks < 9) {
          return Math.floor(weeks).toFixed(0) + " weeks ago";
        } else {
          var month = weeks / 4.0;
          var month1 = Math.floor(month).toFixed(0);
          if (month1 < 2) {
            return "One month ago";
          } else {
            return month1 + " months ago";
          }
        }
      }
    },
    thumbdown(index) {
      var obj = this.reviews[index];
      var context = this;
      if (obj != null) {
        if (
          context.thumbs[obj.reviewid] != null &&
          context.thumbs[obj.reviewid] == 1
        ) {
          context.showbase = true;
          obj.thumbup -= 1;
          if (obj.thumbup < 0) obj.thumbup = 0;
          postReview(obj)
            .then(() => {
              context.showbase = false;
              context.thumbs[obj.reviewid] = 0;
            })
            .catch(function (err) {
              context.showbase = false;
              console.log(err);
            });
        }
      }
    },
    thumbup(index) {
      var obj = this.reviews[index];
      var context = this;
      if (obj != null) {
        if (
          context.thumbs[obj.reviewid] == null ||
          context.thumbs[obj.reviewid] == 0
        ) {
          context.showbase = true;
          obj.thumbup += 1;
          postReview(obj)
            .then(() => {
              context.showbase = false;
              context.thumbs[obj.reviewid] = 1;
            })
            .catch(function () {
              context.showbase = false;
            });
        }
      }
    },
    print() {
      for (var i = this.pagestack.length - 1; i >= 0; i--) {
        if (this.pagestack[i] != null)
          console.log(this.pagestack[i].reviewid.s);
        else console.log("null");
      }
    },
    previousPage(direction) {
      //this.print()
      var context = this;
      var lastkey = null;
      if (direction > 0) {
        lastkey = this.pagestack[this.pagestack.length - 1];
        if (lastkey == null) {
          return;
        }
      } else {
        lastkey = this.pagestack.pop();
        lastkey = this.pagestack.pop();
        lastkey = this.pagestack[this.pagestack.length - 1];
      }
      if (lastkey == null) {
        //console.log("lastkey:"+lastkey)
      } else {
        //console.log("lastkey:"+lastkey.reviewid.s)
      }

      context.showbase = true;
      getReviews(this.reviewproductid, lastkey)
        .then((res) => {
          //console.log(res);
          context.reviews = res.data.results;
          if (res.data.lastEvaluatedKey != null) {
            context.pagestack.push(res.data.lastEvaluatedKey);
          } else {
            context.pagestack.push(null);
          }

          if (res != null) {
            context.showbase = false;
          }
        })
        .catch(function () {
          context.showbase = false;
        });
    },
    toTitleCase(str) {
      return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
    onSubmit() {
      var context = this;
      if (
        this.form.name == null ||
        this.form.name == "" ||
        this.form.city == null ||
        this.form.city == "" ||
        this.form.state == null ||
        this.form.state == "" ||
        this.form.title == null ||
        this.form.title == "" ||
        this.form.email == null ||
        this.form.email == "" ||
        this.form.rating == 0
        
      ) {
        this.show = true;

        setTimeout(function () {
          context.show = false;
        }, 500);
        return;
      }
      this.show = true;

      var obj = {};
      obj.stars = this.form.rating;
      obj.name = this.toTitleCase(this.form.name);
      if (this.form.email != null) {
        obj.email = this.form.email;
      }
      obj.thumbup = 0;
      obj.thumbdown = 0;
      if (this.form.title != null) {
        obj.title = this.form.title;
      }
      if (this.form.comment != null) {
        obj.comment = this.form.comment;
      }
      obj.city = this.toTitleCase(this.form.city);
      obj.createdtime = new Date().toISOString();
      obj.state = this.form.state;
      obj.country = this.form.country;
      obj.reviewproductid = this.reviewproductid;
      postReview(obj)
        .then(() => {
          context.show = false;
          context.$refs["modal-review"].hide();
        })
        .catch(function () {
          context.show = false;
        });
    },
  },
  mounted() {
    var context = this;
    context.showbase = true;
    console.log(store.aa);

    var reviewproductid = "t1";
    var parts = window.location.href.split("?");
    if (parts.length > 1) {
      var parts2 = parts[1].split("&");
      //var state = "";
      for (var i = 0; i < parts2.length; i++) {
        var key = parts2[i].split("=")[0];
        var val = parts2[i].split("=")[1];
        if (key == "product") reviewproductid = val;
        //if (key == "state") state = val;
      }
    }
    this.reviewproductid = reviewproductid;

    getReviews(this.reviewproductid)
      .then((res) => {
        //console.log(res);
        context.reviews = res.data.results;
        if (res.data.lastEvaluatedKey != null) {
          context.pagestack.push(res.data.lastEvaluatedKey);
        }
        if (res != null) {
          context.showbase = false;
        }
      })
      .catch(function () {
        context.showbase = false;
      });

    getReviews()
      .then((res) => {
        var rating = 0;
        var count = 0;
        if (context.reviewproductid == "t1") {
          count = res.data[0].totalcount;
          if (count != 0) {
            rating = res.data[0].totalstar / count;
          }
          this.$refs.reviewpanel.update(
            rating,
            count,
            1,
            0,
            context.reviewproductid
          );
        } else {
          count = res.data[1].totalcount;
          if (count != 0) {
            rating = res.data[1].totalstar / count;
          }
          this.$refs.reviewpanel.update(
            rating,
            count,
            1,
            0,
            context.reviewproductid
          );
        }
      })
      .catch(function () {});
  },
};
</script>

<style lang="scss">
#modal-review .modal-header {
  border-bottom: 0;
}
#modal-review .modal-body {
  padding-top: 0;
}

#modal-review {
  padding-left: 0 !important;
}

input,
.area-select,
.select-special {
  height: 60px !important;
  border-radius: 6px !important;
  border: 2px #bdbdbd solid !important;
  border-color: #201f1f;
  font-size: 16px !important;
}

.additionalPadding {
  padding-top: 24px;
}

.innerlabel {
  position: absolute;
  top: 8px;
  left: 13px;
  font-size: 12px !important;
  color: #33383a;
}

.review-stars {
  width: 20px;
  margin-right: 2px;
}

.review-star-form {
  width: 35px !important;
}

@media (min-width: 1200px) {
  .main-jumbotron {
    padding-left: calc(50% - 600px + 45px) !important;
    padding-right: calc(50% - 600px + 45px) !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}
@media (min-width: 1440px) {
  .main-jumbotron {
    padding-left: calc(50% - 720px + 45px) !important;
    padding-right: calc(50% - 720px + 45px) !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}

.pt-4-big {
  padding-top: 15px !important;
}

@media (max-width: 990px) {
  .pr-0-md {
    padding-right: 0 !important;
  }
}

@media (max-width: 768px) {
  .pt-4-big {
    padding-top: 0 !important;
  }
  .hide-when-small {
    display: none;
  }
  .center-align-small {
    text-align: center !important;
  }
  .pt-2-small {
    padding-top: 15px;
  }
  .pt-1-small {
    padding-top: 5px;
  }

  .pr-0-small {
    padding-right: 0;
  }
}
@media (min-width: 769px) {
  .hide-when-big-769 {
    display: none;
  }
}
</style>